<template>
  <div id="productInformationIdentificationAPP">
    <div>
      <!--      <span>防伪查询</span>-->
    </div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card" style="    margin: 10px;margin-bottom: 10px;margin-top: 30px">
          <div style="font-size: 18px;" :style="text !== '您所扫描的防伪码正确，感谢您对西北轴承的支持！'?'color:red':'color:green'">
            {{ text }}
          </div>
        </el-card>
        <el-card class="box-card" style="    margin: 10px;margin-bottom: 10px;margin-top: 10px">
          <div>
            <div
              style="
                      position: absolute;
                      top: 10px;
                      left: 50px;
                      background: white;
          font-size: 26px;">产品防伪查询</div>
            <div v-if="dialogVisible" style="padding: 0px;padding-top: 0px">
              <div v-for="(item,index) in tableData" :key="index" style="display: flex">
                <div style="padding: 4px;font-weight: bold;flex: 3;text-align-last:justify;text-align: justify;font-size: 14px;padding-bottom: 10px">{{ item.key }}:</div>
                <div style="padding: 4px;flex: 7;font-size: 14px;">{{ item.value }}</div>
              </div>
              <div style="text-align: center;margin-bottom: 30px">
                <el-button style="background-color: red;color: white" @click="editSubmit">一键打假</el-button>
              </div>
            </div>
            <div v-if="!dialogVisible">
              <div>
                <div style="text-align: center;font-size: 14px">
                  营销中心：0951-2021581
                  <br><br>公司邮箱：nxzgroup@nxz.com.cn
                  <br><br>销售邮箱：nxzsale@nxz.com.cn
                  <br><br>办公地址：西北轴承高端轴承产业基地（宁夏银川市西夏区六盘山路388号）
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div
      style="text-align: center;font-size: 18px;position: fixed;
      bottom: 0px;
    padding-bottom: 10px;
    width: 100%;background-color: red;height: 58px;line-height: 28px"><a style="color: white" href="https://www.nxz.com.cn" target="_blank">西北轴承官网:https://www.nxz.com.cn<br>点击直接跳转</a>
    </div>
  </div>
</template>

<script>

import util from '../../commonjs/util'
export default {
  name: 'productInformationIdentificationAPP',
  components: {},
  data() {
    //这里存放数据
    return {
      tableData: [
        { 'key': '防伪码', value: '', keyName: 'securityCode' },
        { 'key': '产品名称', value: '', keyName: 'productName' },
        { 'key': '物料号', value: '', keyName: 'materialNumber' },
        { 'key': '批次号', value: '', keyName: 'batchNumber' },
        { 'key': '批次数量', value: '', keyName: 'number' },
        { 'key': '轴承型号', value: '', keyName: 'bearingType' },
        { 'key': '精度等级', value: '', keyName: 'accuracyClass' },
        { 'key': '执行标准', value: '', keyName: 'executiveStandards' },
        { 'key': '订单型号', value: '', keyName: 'orderModel' },
        { 'key': '生产日期', value: '', keyName: 'dateOfManufacture' },
        { 'key': '发货地', value: '', keyName: 'placeOfDelivery' },
        { 'key': '出厂日期', value: '', keyName: 'dateOfProduction' },
        { 'key': '查询次数', value: '', keyName: 'currentNumberQueries' }
      ],
      dialogVisible: false,
      loading: false,
      formData: {
        id: '',
        securityCode: '',
        queryCompanyName: '',
        checkedBy: '',
        phone: '',
        duplicateQuery: '1',
        contactPhone: '',
        ip: '',
        queryMethod: 'APP端'
      },
      text: '您可以扫描合格证上的防伪码查询真伪，感谢您的支持!'
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.formData.securityCode = this.$route.query.securityCode
    // this.formData.securityCode = '77defab70e60db88'
    if (!util.isNull(this.formData.securityCode)) {
      this.onSubmit()
    } else {
      this.tableData = []
      this.$message.error('防伪码为空，查询失败！')
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    var that = this
    //创建XMLHttpRequest核心对象
    const xhr = new XMLHttpRequest()
    //open()方法来完成Http请求（get方式）
    xhr.open('get', 'https://api.ipify.org/')
    //向服务器发送请求
    xhr.send(null)
    //使用onreadystatechange事件监听XMLHttpRequest对象状态。
    xhr.onreadystatechange = function() {
      //readyState属性代表了 XMLHttpRequest对象的五种状态。4状态为响应内容接收并解析完成
      if (xhr.readyState === 4) {
        that.formData.ip = xhr.responseText
        console.log(xhr.responseText)
      }
    }
  },
  //方法集合
  methods: {
    onSubmit() {
      var that = this
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(position) {
          var latitude = position.coords.latitude
          var longitude = position.coords.longitude
          that.formData.longitude = longitude
          that.formData.latitude = latitude
          that.setSubmit()
        }, function(error) {
          that.setSubmit()
          var msg = {
            0: '未知错误',
            1: '权限拒绝',
            2: '位置不可用',
            3: '请求超时'
          }
          alert('为了更好的体验，请开启位置权限后重新扫码。异常: ' + msg[error.code])
        })
      } else {
        that.setSubmit()
        alert('此浏览器不支持地理定位。')
      }
      // axios.get('https://qifu-api.baidubce.com/ip/local/geo/v1/district').then((res) => {
      //   if (res.data.msg === '查询成功') {
      //     that.formData.ip = res.data.ip
      //     that.formData.longitude = res.data.data.lng
      //     that.formData.latitude = res.data.data.lat
      //     that.formData.province = res.data.data.continent + res.data.data.country + res.data.data.prov
      //     that.formData.market = res.data.data.city
      //     that.formData.distinguish = res.data.data.district
      //
      //     that.$post('/xbzcsnms/arcScancoderecord/queryProduct.z', this.formData).then((res) => {
      //       loading2.close()
      //       if (res.success && res.dataList.length > 0) {
      //         that.formData.id = res.id
      //         var data = res.dataList[0]
      //         that.tableData = that.$options.data().tableData
      //         that.tableData.forEach((v, k) => {
      //           if (v.key === '出厂日期' || v.key === '生产日期') {
      //             v.value = data[v.keyName].length > 10 ? data[v.keyName].split(' ')[0] : data[v.keyName]
      //           } else {
      //             v.value = data[v.keyName]
      //           }
      //         })
      //         var newTableData = []
      //         that.tableData.forEach((v, k) => {
      //           if (v.key === '查询次数' || v.key === '批次数量') {
      //             newTableData.push(v)
      //           } else if (!util.isNullString(v.value)) {
      //             newTableData.push(v)
      //           }
      //         })
      //         that.tableData = newTableData
      //         this.dialogVisible = true
      //         that.text = '您所扫描的防伪码正确，感谢您对西北轴承的支持！'
      //       } else {
      //         this.dialogVisible = false
      //         that.text = '您所扫描的防伪码不存在，请通过正规渠道购买本公司产品！'
      //       }
      //     }).catch((err) => {
      //       that.$message.error('查询数据异常！请联系管理员！')
      //     })
      //   }
      // }).catch((err) => {
      //   that.$message.error('获取ip地址失败！')
      // })
    },
    setSubmit() {
      var that = this
      const loading2 = this.$loading({
        lock: true,
        text: '获取数据中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      that.$post('/xbzcsnms/arcScancoderecord/queryProduct.z', this.formData).then((res) => {
        loading2.close()
        if (res.success && res.dataList.length > 0) {
          that.formData.id = res.id
          var data = res.dataList[res.dataList.length - 1]
          that.tableData = that.$options.data().tableData
          that.tableData.forEach((v, k) => {
            if (!util.isNull(data[v.keyName]) && v.key === '出厂日期' || v.key === '生产日期') {
              v.value = data[v.keyName].length > 10 ? data[v.keyName].split(' ')[0] : data[v.keyName]
            } else {
              v.value = data[v.keyName]
            }
          })
          var newTableData = []
          that.tableData.forEach((v, k) => {
            if (v.key === '查询次数' || v.key === '批次数量') {
              newTableData.push(v)
            } else if (!util.isNullString(v.value)) {
              newTableData.push(v)
            }
          })
          that.tableData = newTableData
          this.dialogVisible = true
          that.text = '您所扫描的防伪码正确，感谢您对西北轴承的支持！'
        } else {
          this.dialogVisible = false
          that.text = '您所扫描的防伪码不存在，请通过正规渠道购买本公司产品！'
        }
      }).catch((err) => {
        that.$message.error('查询数据异常！请联系管理员！')
      })
    },
    editSubmit() {
      var that = this
      var data = {
        duplicateQuery: '0',
        id: this.formData.id
      }
      that.$post('/xbzcsnms/arcScancoderecord/editArcScancodereord.z', data).then((res) => {
        if (res.success) {
          this.$prompt('请输入联系方式', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            inputErrorMessage: '联系方式格式不正确'
          }).then(({ value }) => {
            this.formData.contactPhone = value
            this.editPhone()
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消输入'
            })
          })
        } else {
          that.$message.error(res.msg)
        }
      }).catch((err) => {
        that.$message.error('保存数据异常！请联系管理员！')
      })
    },
    editPhone() {
      var that = this
      var data = {
        contactPhone: this.formData.contactPhone,
        id: this.formData.id
      }
      that.$post('/xbzcsnms/arcScancoderecord/editArcScancodereord.z', data).then((res) => {
        if (res.success) {
          this.formData.contactPhone = ''
          that.$message.success('打假信息提交成功！')
        } else {
          that.$message.error(res.msg)
        }
      }).catch((err) => {
        that.$message.error('保存数据异常！请联系管理员！')
      })
    },
    empy() {
      this.formData = this.$options.data().formData
      this.$refs.form.clearValidate()
      this.tableData = this.$options.data().tableData
    },
    handleClose() {
      this.dialogVisible = false
      this.tableData = []
    }
  } //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>
.el-message-box{
  width: 80%;
}
</style>
<style scoped>
#productInformationIdentificationAPP{
.el-input{
  width: 90%;
}
}
</style>
